import {
  Box,
  Heading,
  Text,
  Image,
  VStack,
  Badge,
  Card,
  CardBody,
  List,
  ListItem,
  Flex,
} from "@chakra-ui/react";
import { ArrowForwardIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";

const CaseStudies = ({ study, boxProps }) => {
  const navigate = useNavigate();

  return (
    <>
      <Card
        bg="white"
        borderRadius="xl"
        overflow="hidden"
        shadow="md"
        transition="all 0.3s"
        _hover={{
          shadow: "lg",
          transform: "translateY(-2px)",
        }}
        h="full"
        minW={0}
        maxW="100%"
        height={boxProps?.height || "auto"}
        width={
          boxProps?.width || {
            base: "100%",
            sm: "100%",
            md: "320px",
            lg: "350px",
            xl: "380px",
          }
        }
        {...boxProps}
        onClick={() => {
          const identifier = study.slug || study.documentId || study.id;
          navigate(`/case-studies/${identifier}`);
        }}
      >
        {/* Card Image */}
        <Box position="relative" h="200px" overflow="hidden">
          <Image
            src={study.image}
            alt={study.title}
            w="full"
            h="full"
            objectFit="cover"
            transition="transform 0.3s"
            _hover={{ transform: "scale(1.05)" }}
          />
          <Box
            position="absolute"
            top="0"
            left="0"
            right="0"
            bottom="0"
            bg="blackAlpha.200"
          />
        </Box>

        <CardBody p={5} display="flex" flexDirection="column" h="full">
          <VStack spacing={3} align="stretch" flex="1">
            {/* Title */}
            <Heading
              as="h3"
              fontSize="lg"
              fontWeight="bold"
              color="#000B8C"
              lineHeight="tight"
              mb={2}
              noOfLines={2}
            >
              {study.title}
            </Heading>

            {/* Description */}
            <Text
              color="gray.600"
              fontSize="sm"
              lineHeight="1.5"
              noOfLines={3}
              mb={3}
              minH="60px"
            >
              {study.description}
            </Text>

            
          </VStack>

          {/* Category and Arrow - Always at bottom */}
          <Flex justify="end" align="center" pt={3} mt="auto">
           
            <Box
              as="button"
              w="8"
              h="8"
              borderRadius="full"
              border="1px"
              borderColor="#000B8C"
              color="#000B8C"
              display="flex"
              alignItems="center"
              justifyContent="center"
              transition="all 0.3s"
              _hover={{
                bg: "#000B8C",
                color: "white",
                transform: "translateX(2px)",
              }}
            >
              <ArrowForwardIcon w={3} h={3} />
            </Box>
          </Flex>
        </CardBody>
      </Card>
    </>
  );
};

export default CaseStudies;
